<template lang="pug">
  #CustomerUsersModel.CustomerModel.CustomerModel-usersModel.p-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content
      b-input-group.mb-3
        b-form-input(
          v-model="searchInput",
          placeholder="請輸入關鍵字"
        )
        b-input-group-append
          b-input-group-text
            i.fas.fa-search
          b-button(
            variant="primary",
            size="sm",
            @click="autoSelectHandler()"
          ) 全選/清除
      .mb-2
        b-card.border-0.customerCard(
          bg-variant="light",
          v-for="(user,index) in filterUsers",
          :key="user.id"
        )
          .row.no-gutters
            .col-1.d-flex.align-items-center.justify-content-center
              b-form-checkbox(
                :id="`checkbox-group-${index}`",
                v-model="selectUsersId",
                :name="`user-${index}`",
                :value="user.member_id"
              )
            .col-11
              label.w-100.mb-0(
                :for="`checkbox-group-${index}`"
              )
                .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
                  .col-6.pr-1
                    ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '80px', 'height': '80px' }"
                    )
                  .col-6.pl-1
                    p.mb-0.font-weight-bold LINE暱稱 {{ user.line_display_name }}
                    p.mb-0 備註名稱 {{ user.note_name }}
                .bindRow.mb-2.d-flex.align-items-center
                  i.far.fa-calendar-check.mr-2
                  small 綁定日期：{{ user.latest_sa_binding_at }}
                .labelRow.d-flex.align-items-center.flex-wrap
                  i.fas.fa-tag.mr-2
                  small 顧客標籤：
                  b-badge.m-1.rounded-50.px-3.py-2(
                    variant="primary",
                    v-for="label in user.tags"
                    :key="label.id"
                  ) {{ label }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles",
          ref="infiniteLoading"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
      p.mb-3(
        v-if="filterUsers.length === 0"
      ) 無可標籤的顧客
      .px-4
        .row
          .col-6
            b-button(
              variant="primary",
              block,
              @click="closeModel()"
            ) 取消
          .col-6
            b-button(
              variant="primary",
              block,
              @click="submitHandler()"
            ) 選擇確認
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';

const _ = require('lodash');

export default {
  name: 'UsersModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    selectUsers: [Array, Object]
  },
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      searchInput: null,
      selectUsersId: [],
      infiniteId: +new Date(),
      mode: null
    };
  },
  mounted() {
    this.$EventBus.$on('openUsersModel', (mode) => {
      if (!mode) return;
      this.mode = mode;
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectUsersId = [];
      vm.searchInput = null;
      vm.$store.commit('sa_label/resetInfiniteLoadingData');

      // 把原本有選擇的人放進來
      _.forEach(vm.selectUsers, (res) => {
        vm.selectUsersId.push(res.member_id);
      });

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      let apiTarget;

      switch (vm.mode) {
        case 'ba':
          apiTarget = 'getMemberListHandler';
          break;
        case 'backend':
          apiTarget = 'getBackendMemberListHandler';
          break;
        default:
          break;
      }

      if (!vm.mode || !apiTarget) {
          vm.$swal.fire({
          icon: 'error',
          title: '編輯目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sa_label/${apiTarget}`, {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.mode = null;
      this.showModel = false;
    },
    autoSelectHandler() {
      const vm = this;
      if (!vm.selectUsersId || vm.selectUsersId.length === 0) {
        _.forEach(vm.memberList, (user) => {
          vm.selectUsersId.push(user.member_id);
        });
      } else vm.selectUsersId = [];
    },
    submitHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '處理中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const selectUsersArr = [];

      _.forEach(vm.memberList, (res) => {
        if (vm.selectUsersId.indexOf(res.member_id) !== -1) {
          selectUsersArr.push(res);
        }
      });

      vm.$store.commit('sa_label/setSelectUsers', selectUsersArr);
      // TODO: 因原本僅存放置sa vueX 故sm vueX 取不到名單 所以先補上
      vm.$store.commit('sm_label/setSelectUsers', selectUsersArr);
      vm.$swal.close();
      vm.closeModel();
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_label.memberList,
      pagination: (state) => state.sa_label.pagination
    }),
    filterUsers() {
      const vm = this;
      if (!vm.searchInput || vm.searchInput === '') {
        return vm.memberList;
      }
      return vm.memberList.filter((user) => user.line_display_name.includes(vm.searchInput));
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openUsersModel');
  }
};
</script>

<style>

</style>
